import { CISO_OASIS_API } from '@/api';
import moment from 'moment';
import config from './weimRseCapacityTestsConfigs';

const state = {
  tableData: [],
  tableConfig: config.fields,
  tableExportConfig: {},
};

const actions = {
  async fetchWeimRseCapacityTests({ commit }, args) {
    commit('setTableData', []);

    const params = {
      startDate: args.tradeDateRangeSelected[0].format('YYYY-MM-DD'),
      endDate: args.tradeDateRangeSelected[1].format('YYYY-MM-DD'),
      marketType: 'RTM', // as of now, only RTM is supported
      baa: args.balancingAuthorityAreaSelected,
      oasisSnapshotIndicator: args.oasisSnapshotIndicatorSelected,
    };
    try {
      const headers = { Accept: 'application/json' };
      const { data } = await CISO_OASIS_API.get('/weim-rse-capcity-test', { params, headers });
      const flattenData = data.flatMap((row) => {
        const date = moment(row.tradingDate).format('YYYY-MM-DD');
        const map = Object.entries(row.dataTypeToValueMapping);
        const dataTypeNameMapping = (dataTypeName) => {
          switch (dataTypeName) {
          case 'bidRangeCap': return 'Bid Range Capacity';
          case 'expBaseSch': return 'Export Base Schedule';
          case 'genBaseSch': return 'Generation Base Schedule';
          case 'impBaseSch': return 'Import Base Schedule';
          case 'insufficiencyAmount': return 'Insufficiency Amount';
          case 'insufficiencyPercentage': return 'Insufficiency %';
          case 'itieUncert': return 'Intertie Uncertainty';
          case 'loadForecast': return 'BAA Load Forecast';
          case 'netBaseSch': return 'Net Schedule Interchange';
          case 'netLoadUncert': return 'Net-Load Uncertainty';
          case 'requirementAmount': return 'Requirement Amount';
          case 'testStatus': return 'Test Status Pass';
          default:
            return dataTypeName;
          }
        };
        const valueMapping = (value) => {
          switch (value) {
          case 'PASS': return 1;
          case 'FAIL': return 0;
          default:
            return value;
          }
        };
        return map.map(([dataType, value]) => (
          {
            tradingDate: date,
            tradingHour: row.tradingHour,
            marketType: row.marketType,
            baa: row.baa,
            snapshotIndicator: row.snapshotIndicator,
            curveDirection: row.curveDirection,
            testIndicator: row.testIndicator,
            dataType: dataTypeNameMapping(dataType),
            value: valueMapping(value),
          }));
      });

      commit('setTableData', flattenData);

      // save parameters for export
      // const tableExportConfig = {
      //   requestAPI: CISO_OASIS_API,
      //   requestURL: '/oasis-prices',
      //   requestParams: params,
      // };
      // commit('setTableExportConfig', tableExportConfig);
    } catch {
      this.$notify('Failed to retrieve WEIM RSE Capacity Tests', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
    commit('setTableExportConfig', {});
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
  setTableExportConfig(state, value) {
    state.tableExportConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};